import React from 'react'
import ReactDOM from 'react-dom'

import Tooltip from '../../../tooltip'

import { Td, DataItem, DataItemLink, SubCount, SubStyle } from './TableCell.styles'

const TableCellComponent = ({ dataItem, style, className, children, flag, subStyling, showToolTip, lastColumn, firstColumn, count, events, width, subRef, analytics }) => {
  const subWidth = (subRef)? ReactDOM.findDOMNode(subRef).offsetWidth : null
  let ttWidth = null;
  
  if(subWidth) {
    ttWidth = (width - subWidth)

    // this can easily be messed around with by the authors. Let's not allow them to create a table cell with a container of negative size
    if(ttWidth < 0) {
      ttWidth = 1
    }
  } 

  let modSubStyling = null

  if (subStyling && subStyling.label && subStyling.label.content && showToolTip) {
    modSubStyling = subStyling.label.styling
    modSubStyling.top = (dataItem)? '-7px' : '-2px'
  }

  if (subStyling && subStyling.label && subStyling.label.content && !showToolTip) {
    modSubStyling = subStyling.label.styling
  }
  
  return (
    <Td style={style} className={className} data-testid='grid-cell'>
      {flag}
      <DataItem showToolTip={showToolTip} count={count} style={subStyling.styling}>
        {subStyling && subStyling.label && subStyling.label.content &&
          <SubStyle style={modSubStyling} ref={events.captureSubRef}>{subStyling.label.content} &nbsp;</SubStyle>
        }
        {children}
        {showToolTip && dataItem &&
          <Tooltip ttWidth={ttWidth} lastColumn={lastColumn} firstColumn={firstColumn} style={{top: '0px'}} truncate={true} text={dataItem} {...events}>{dataItem}</Tooltip>
        }
        {!showToolTip && dataItem}
      </DataItem>
    </Td>
  )
}

const TableCellMultiLineComponent = ({ dataItem, dataItemStyle, style, className, children, flag, subStyling, showToolTip, lastColumn, firstColumn, count, link, env, dataRow, events }) => {

  const styledDataItem = dataItem.map((item, i) => {
    if (link && typeof link === 'object' && link.callback) {
      return (
        <DataItem key={'TableCellMultiLineComponent_' + i} className={dataItemStyle} count={count} style={subStyling.styling}>
          <DataItemLink href='/'
            onContextMenu={(evt) => {
              evt.preventDefault()
            }}
            onClick={(evt) => {
              evt.preventDefault()
              events.handleLinkClick()

              env.callFunction(link.callback, [dataRow])
            }}
            style={subStyling.styling}>
            {subStyling && subStyling.label && subStyling.label.content &&
              <span style={subStyling.label.styling}>{subStyling.label.content} &nbsp;</span>
            }
            {item}
          </DataItemLink>
        </DataItem>
      )
    } else if (link && typeof link === 'string') {
      return (
        <DataItem key={'TableCellMultiLineComponent_' + i} className={dataItemStyle} count={count} style={subStyling.styling}>
          <DataItemLink 
            onContextMenu={(evt) => {
              evt.preventDefault()
            }}
            onClick={events.handleLinkClick}
            href={link}
            style={subStyling.styling}>
            {subStyling && subStyling.label && subStyling.label.content &&
              <span style={subStyling.label.styling}>{subStyling.label.content} &nbsp;</span>
            }
            {item}
          </DataItemLink>
        </DataItem>
      )
    } else {
      return (
        <DataItem key={'TableCellMultiLineComponent_' + i} className={dataItemStyle} showToolTip={showToolTip} count={count} style={subStyling.styling}>
          {subStyling && subStyling.label && subStyling.label.content &&
            <span style={subStyling.label.styling}>{subStyling.label.content} &nbsp;</span>
          }
          {children}
          {showToolTip && item &&
            <div>
              <Tooltip lastColumn={lastColumn} firstColumn={firstColumn} style={{top: '0px'}} truncate={true} text={item} {...events}>{item}</Tooltip>
            </div>
          }
          {showToolTip && !item &&
            <div>
              &nbsp;
            </div>
          }
          {!showToolTip && item}
        </DataItem>
      )
    }
  })

  return (
    <Td style={style} className={className} data-testid='grid-cell'>
      {flag}
      {styledDataItem}
    </Td>
  )
}

const TableCellLinkComponent = props => {
  const { dataItem, style, className, children, flag, subStyling, link, env, dataRow, events, showToolTip, firstColumn, lastColumn } = props
  const text = dataItem || ' '

  const cellContent = <React.Fragment>
    {typeof link === 'object' && link.callback &&
      <DataItemLink href='/'
        onContextMenu={(evt) => {
          evt.preventDefault()
        }}
        onClick={(evt) => {
          evt.preventDefault()
          env.callFunction(link.callback, [dataRow])
        }}
        style={subStyling.styling}>
        {subStyling && subStyling.label && subStyling.label.content &&
          <span style={subStyling.label.styling}>{subStyling.label.content} &nbsp;</span>
        }
        {text}
      </DataItemLink>
    }
    {typeof link === 'string' &&
      <DataItemLink
        onContextMenu={(evt) => {
          evt.preventDefault()
        }}
        href={link}
        style={subStyling.styling}>
        {subStyling && subStyling.label && subStyling.label.content &&
          <span style={subStyling.label.styling}>{subStyling.label.content} &nbsp;</span>
        }
        {text}
      </DataItemLink>
    }
  </React.Fragment>

  return (
    <Td style={style} className={className} data-testid='grid-cell'>
      {flag}
      {children}
      {showToolTip 
        ? <Tooltip lastColumn={lastColumn} firstColumn={firstColumn} style={{top: '1px'}} truncate={true} text={text} {...events}>
            {cellContent}
          </Tooltip>
        : cellContent}
    </Td>
  )
}

const TableCellActionComponent = ({ dataItem, style, className, children, multiselected }) => {
  const classes = className + ' actions-cell'
  
  return (
    <Td style={style} className={classes} data-testid='grid-cell'>
      {dataItem}
    </Td>
  )
}

const TableCellCountComponent = ({ count, style }) => {
  return (
    <Td style={style} data-testid='grid-cell'>
      <SubCount>{count}</SubCount>
    </Td>
  )
}

export { TableCellComponent, TableCellActionComponent, TableCellCountComponent, TableCellLinkComponent, TableCellMultiLineComponent }
